export default __webpack_public_path__ + "static/aboutMain-6737050fef285bc01d3b51cb987286c5.png";